export var CheckboxStyles = function CheckboxStyles(props) {
  var disabled = props.disabled,
      checked = props.checked,
      theme = props.theme;
  var semanticColors = theme.semanticColors,
      palette = theme.palette,
      effects = theme.effects;
  return {
    checkbox: [{
      borderRadius: effects.roundedCorner2,
      borderColor: palette.neutralPrimary
    }, !disabled && checked && {
      borderColor: semanticColors.inputBackgroundChecked // using semanticColor because I am setting a new color above

    }, disabled && {
      borderColor: palette.neutralTertiaryAlt
    }, checked && disabled && {
      background: palette.neutralTertiaryAlt,
      borderColor: palette.neutralTertiaryAlt
    }],
    checkmark: {
      color: semanticColors.inputForegroundChecked // using semanticColor to override original behavior on checked/disabled

    },
    root: [!disabled && [!checked && {
      selectors: {
        ':hover .ms-Checkbox-text': {
          color: palette.neutralDark
        },
        ':hover .ms-Checkbox-checkmark': {
          color: palette.neutralSecondary
        }
      }
    }, checked && {
      selectors: {
        ':hover .ms-Checkbox-checkbox': {
          background: palette.themeDark,
          borderColor: palette.themeDark
        },
        ':focus .ms-Checkbox-checkbox': {
          background: palette.themeDark,
          borderColor: palette.themeDark
        }
      }
    }]]
  };
};